import createClient from 'openapi-fetch';
import { PROBLEM_CONTENT_TYPE, problemSchema } from '@reos/schemas';
export function createApiClient(options) {
    return createClient({
        baseUrl: options.baseUrl,
        // Session cookie (better-auth) - klient a API jsou casto na jinem originu
        // (web-admin :5173 vs api :3000 v devu, samostatne subdomeny v ostrem
        // provozu). Bez toho fetch cookie neposle a kazdy pozadavek dostane 401.
        credentials: 'include',
        ...(options.headers !== undefined ? { headers: options.headers } : {}),
        ...(options.fetch !== undefined ? { fetch: options.fetch } : {}),
    });
}
/** Fragment hlavicky Idempotency-Key pro `params.header` mutaci. */
export function idempotencyKey(key) {
    return { 'idempotency-key': key };
}
/**
 * Precte a zvaliduje problem+json z odpovedi. Vrati null, kdyz odpoved
 * problemem neni (klient tak nemuze slepe duverovat chybovemu tela).
 */
export async function parseProblem(response) {
    const contentType = response.headers.get('content-type') ?? '';
    if (!contentType.includes(PROBLEM_CONTENT_TYPE))
        return null;
    const payload = await response.json();
    const parsed = problemSchema.safeParse(payload);
    return parsed.success ? parsed.data : null;
}
//# sourceMappingURL=client.js.map